import React, { useEffect, useState } from "react";
import Tile from "../../components/tile";
import VideoBanner from "../../components/videoBanner";
import TileTools from "../../components/tileTools";
import img_pajaro_herramientas from "../../assets/images/img_pajaro_herramientas.png";
import img_banner_herramientas from "../../assets/images/img_banner_herramientas.svg";
import genially from "../../assets/images/genially.png";
import jaguar from "../../assets/images/jaguar.png";
import img_banner_genially from "../../assets/images/img_banner_genially.jpg";
import img_banner_jaguar from "../../assets/images/img_banner_jaguar.jpg";
import img_banner_jaguar_mobile from "../../assets/images/jaguar_mobile.jpg";
import img_banner_genially_mobile from "../../assets/images/genially_mobile.jpg";
import img_ondas from "../../assets/images/img_ondas.png";
import ico_handy from "../../assets/icons/ico_handy.svg";
import ico_ubicacion from "../../assets/icons/ico_ubicacion.svg";
import ico_hoja from "../../assets/icons/ico_hoja.svg";
import ico_libro from "../../assets/icons/ico_libro.svg";
import TileToolsMobile from "../../components/titleToolsMobile";
import img_portada_main from "../../assets/images/img_portada_main.jpg";
const MainPageScreen = () => {
  const main_page_video =
    "mMN2daZ2pUg";
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  return (
    <div className="w-full bg-[#002E0F] relative">
      <div className="w-full lg:h-[1080px]  absolute z-10">
        {width > 770 ? (
          <VideoBanner idVideo={main_page_video}></VideoBanner>
        ) : (
          <div className="relative">
            <img
              src={img_portada_main}
              className=" object-fill w-full   h-full lg:-bottom-24 md:-bottom-24 sm:-bottom-16 -bottom-16  "
            ></img>
            <div className="bg-gradient-to-t absolute w-full bottom-0 from-[#002E0F] h-64"></div>
          </div>
        )}
      </div>

      <div className="w-full text-white relative z-10 ">
        <div className="lg:py-80 md:py-[20rem] sm:py-20 py-20 lg:mb-52 md:mb-0 sm:mb-10 lg:pt-64 md:pt-[7rem] sm:pt-[35rem] pt-[25rem] relative w-full h-fit md:max-h-[22rem] object-contain flex flex-col lg:items-end md:items-end sm:items-center lg:px-0 md:px-0 sm:px-10 px-10 items-center text-white ">
          <div className="break-words  lg:text-right md:text-right sm:text-left text-left lg:mr-36 md:mr-16 sm:mr-0 mr-0  lg:items-end md:items-end sm:items-center lg:right-0 lg:w-[50%] md:w-full sm:w-full w-full min-w-[10rem] max-h-32 ">
            <h1 className=" 2xl:text-7xl xl:text-5xl lg:text-5xl md:text-4xl sm:text-4xl text-3xl font-bold md:mb-3 sm:mb-3 mb-3 lg:text-right md:text-right sm:text-center text-center">
              Herramientas sencillas <br /> para el monitoreo <br /> de
              biodiversidad
            </h1>
            <p className=" 2xl:block xl:block lg:block md:hidden sm:hidden hidden 2xl:text-xl xl:text-lg lg:text-base md:text-xs sm:text-sm text-sm lg:mb-10 md:mb-3 sm:mb-3 mb-3 lg:text-right md:text-right sm:text-center text-center">
              Han quedado atrás los días en que la naturaleza y la actividad
              económica se consideraban opuestas... El capital natural es lo que
              hace posible las operaciones de una empresa y por eso, hemos
              construido esta guía.
            </p>
            <p className="2xl:hidden xl:hidden lg:hidden md:block sm:block block 2xl:text-xl xl:text-lg lg:text-base md:text-xs sm:text-sm text-sm lg:mb-10 md:mb-3 sm:mb-3 mb-3 lg:text-right md:text-right sm:text-center text-center">
              Han quedado atrás los días en que la naturaleza y la actividad
              económica se consideraban opuestas... El capital <br /> natural es
              lo que hace posible las operaciones de una empresa y por eso,
              hemos construido esta guía.
            </p>
            <h4 className="2xl:text-3xl xl:text-2xl lg:text-xl md:text-base sm:text-base text-base font-bold md:mb-3 sm:mb-3 mb-3 lg:text-right md:text-right sm:text-center text-center">
              ¡Aprenda a monitorear la flora y fauna de su entorno!
            </h4>
            <p className="2xl:text-xl xl:text-lg  lg:text-base md:text-xs sm:text-sm text-sm md:mb-3 sm:mb-3 mb-3 lg:text-right md:text-right sm:text-center text-center">
              Y asegure el flujo de bienes y servicios medioambientales que hace
              posible la vida humana.
            </p>
          </div>
        </div>

        <div className="grid lg:pt-[13rem] md:pt-[0rem] sm:pt-[15rem] pt-[15rem] relative lg:px-28 md:px-16 lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-1 pb-20 min-w-[10rem]">
          <div className="lg:col-span-3 md:col-span-3 sm:col-span-1 col-span-1 text-left lg:mr-10 mr-10 sm:bottom-0 from-[#002E0F]  w-full">
            {width > 770 ? (
              <TileTools
                bgImage={img_banner_herramientas}
                icon={ico_handy}
                firstImage={img_pajaro_herramientas}
                secondImage={img_ondas}
                page={"../herramientas"}
                width={"w-full"}
                height={"h-fit"}
                bgColor={"bg-[#048CC6]"}
                title="Tile de prueba"
                buttonText={"Ver herramientas"}
                text1={
                  <h1 className="z-30 relative 2xl:text-6xl xl:text-3xl lg:text-2xl md:text-base sm:text-base text-base lg:text-left md:text-left sm:text-center mr-14 2xl:mb-5 xl:mb-10 lg:mb-5 md:mb-0 sm:mb-0 mb-0 2xl:mt-10 xl:mt-10 lg:mt-16 md:mt-24 sm:mt-2 mt-2 font-bold text-left ">
                    Herramientas sencillas <br /> para el monitoreo
                  </h1>
                }
              ></TileTools>
            ) : (
              <TileToolsMobile
                bgImage={null}
                icon={ico_handy}
                firstImage={img_pajaro_herramientas}
                secondImage={img_ondas}
                page={"../herramientas"}
                width={"w-full"}
                height={"h-fit"}
                bgColor={"bg-[#048CC6]"}
                title="Tile de prueba"
                buttonText={"Ver herramientas"}
                text1={"Herramientas sencillas"}
                text2={"para el monitoreo"}
              ></TileToolsMobile>
            )}
          </div>
          <Tile
            icon={ico_hoja}
            page={"../grupos"}
            bgColor={"bg-[#009269]"}
            title={
              <h1 className="2xl:text-4xl xl:text-3xl lg:text-2xl md:text-base sm:text-base text-base  lg:text-left md:text-left sm:text-center text-center  font-bold mr-14 mb-5 lg:mt-20 md:mt-20 sm:mt-5 mt-5">
                Grupos para <br /> monitorear
              </h1>
            }
            buttonText={"Ver grupos"}
          ></Tile>
          <Tile
            icon={ico_ubicacion}
            page={"../especies"}
            bgColor={"bg-[#F2B229]"}
            title={
              <h1 className="2xl:text-4xl xl:text-3xl lg:text-2xl md:text-base sm:text-base text-base  lg:text-left md:text-left sm:text-center text-center  font-bold mr-14 mb-5 lg:mt-20 md:mt-20 sm:mt-5 mt-5">
                Especies para <br /> enfocar el monitoreo
              </h1>
            }
            buttonText={"Ver especies"}
          ></Tile>
          <Tile
            target="_blank"
            icon={ico_libro}
            page={
              "https://drive.google.com/file/d/1qiYNbhEEffEm8PZaPg5noivACUO9AT6n/view?usp=sharing"
            }
            bgColor={"bg-[#82AB40]"}
            title={
              <h1 className="2xl:text-4xl xl:text-3xl lg:text-2xl md:text-base sm:text-base text-base  lg:text-left md:text-left sm:text-center text-center  font-bold mr-14 mb-5 lg:mt-20 md:mt-20 sm:mt-5 mt-5">
                Aprende más <br /> con nuestro libro
              </h1>
            }
            buttonText={"Descargar Ebook"}
          ></Tile>
        </div>
      </div>

      <div className="grid relative lg:px-28 md:px-16 lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-1 pb-20 min-w-[10rem]">
        <div className="text-white lg:col-span-3 md:col-span-3 sm:col-span-1 col-span-1 text-left lg:mr-10 mr-10 sm:bottom-0 from-[#002E0F]  w-full">
          {width > 770 ? (
            <TileTools
              bgImage={img_banner_genially}
              icon={""}
              centerImage={genially}
              page={"../experiencia"}
              width={"w-full"}
              height={"h-fit"}
              bgColor={"bg-[#048CC6]"}
              title="Tile de prueba"
              buttonText={"Ver experiencia"}
              text1={
                <h1 className="z-30  relative 2xl:text-6xl xl:text-3xl lg:text-2xl md:text-base sm:text-base text-base lg:text-left md:text-left sm:text-center mr-14 2xl:mb-5 xl:mb-5 lg:mb-5 md:mb-0 sm:mb-0 mb-0 2xl:-mt-5 xl:mt-5 lg:mt-5 md:mt-10 sm:mt-2 mt-2 font-bold text-left ">
                  Ponga a prueba su <br /> conocimiento con las <br />{" "}
                  experiencias interactivas
                </h1>
              }
            ></TileTools>
          ) : (
            <TileToolsMobile
              bgImage={img_banner_genially_mobile}
              icon={""}
              centerImage={genially}
              page={"../experiencia"}
              width={"w-full"}
              height={"h-fit"}
              bgColor={"bg-[#048CC6]"}
              title="Tile de prueba"
              buttonText={"Ver experiencia"}
              text1={"Ponga a prueba su conocimiento"}
              text2={"con las experiencias interactivas"}
            ></TileToolsMobile>
          )}
        </div>
      </div>
      <div className="grid relative lg:px-28 md:px-16 lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-1 pb-20 min-w-[10rem]">
        <div className="text-white lg:col-span-3 md:col-span-3 sm:col-span-1 col-span-1 text-left lg:mr-10 mr-10 sm:bottom-0 from-[#002E0F]  w-full">
          {width > 770 ? (
            <TileTools
              bgImage={img_banner_jaguar}
              icon={""}
              centerImage={jaguar}
              page={"https://menu-eight-peach.vercel.app/"}
              width={"w-full"}
              height={"h-fit"}
              bgColor={"bg-[#048CC6]"}
              title="jaguar"
              buttonText={"Entrar"}
              text1={
                <h1 className="z-30 relative 2xl:text-6xl xl:text-3xl lg:text-2xl md:text-base sm:text-base text-base lg:text-left md:text-left sm:text-center mr-14 2xl:mb-5 xl:mb-10 lg:mb-5 md:mb-0 sm:mb-0 mb-0 2xl:mt-10 xl:mt-10 lg:mt-16 md:mt-24 sm:mt-2 mt-2 font-bold text-left ">
                  Aprenda a monitorear con la <br /> Actividad Interactiva WebVR
                </h1>
              }
            ></TileTools>
          ) : (
            <TileToolsMobile
              bgImage={img_banner_jaguar_mobile}
              icon={""}
              centerImage={jaguar}
              page={"https://menu-eight-peach.vercel.app/"}
              width={"w-full"}
              height={"h-fit"}
              bgColor={"bg-[#048CC6]"}
              title="jaguar"
              buttonText={"Entrar"}
              text1={"Aprenda a monitorear con la"}
              text2={"Actividad Interactiva WebVR"}
            ></TileToolsMobile>
          )}
        </div>
      </div>

      <div className="static flex flex-col w-full h-full left-0 right-0 z-50 items-center text-white  lg:pb-52 md:ob-20 sm:pb-20 pb-20  bg-[#002E0F]">
        <div className=" pr-10 min-w-[20rem] lg:inline-flex md:inline-block sm:inline-block inline-block lg:px-32 md:px-20 sm:px-5 px-5">
          <h4 className="xl:text-3xl lg:text-2xl md:text-2xl sm:text-2xl text-2xl font-bold  w-fit pr-10 mb-5">
            El programa Biodiversidad <br /> y Negocios en Centroamérica <br />{" "}
            y República Dominicana (daBio)
          </h4>
          <div className="grid grid-rows-2 ">
            <p className="xl:text-lg lg:text-base md:text-base sm:text-base text-sm mt-5">
              Tiene como objetivo que el sector privado de la región
              destinataria, América Central y República Dominicana, reconozca la
              importancia económica de la diversidad biológica y, en cooperación
              con los principales actores del gobierno, de la ciencia y de la
              sociedad civil, contribuya a la protección y al uso sostenible en
              los ecosistemas terrestres y marinos.
            </p>
            <p className="xl:text-lg lg:text-base md:text-base sm:text-base text-sm mt-5">
              El programa desarrolla sus actividades en cooperación con la
              Secretaria General del Sistema Integración Centroamericana
              (SG-SICA) y la Comisión Centroamericana de Ambiente y Desarrollo
              (CCAD), por encargo del Ministerio Federal Alemán de Cooperación
              Económica y Desarrollo (BMZ).
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainPageScreen;
